import React, { useState, useEffect } from 'react'
import Layout from '../layout/Layout'
import { TbLoader3 } from "react-icons/tb";
import { FaRegTrashAlt } from "react-icons/fa";
import { toast } from 'sonner';

const Favoritos = () => {
    const [favoritos, setFavoritos] = useState([])
    const [loading, setLoading] = useState(true);

    const fetchFavoritos = async (parsedFavoritos) => {
        if (!Array.isArray(parsedFavoritos) || parsedFavoritos.length === 0) {
            setFavoritos([]);
            setLoading(false);
            return;
        }

        const updatedFavoritos = [];
        for (const item of parsedFavoritos) {
            try {
                console.log('Fetching item:', item);
                const response = await fetch('https://muebleria-villarreal.com/apimv/articuloController.php?grupo=' + item.grupo + '&articulo=' + item.articulo);
                const data = await response.json();
                console.log('API Response:', data);
                
                if (data && data.articulo && data.articulo.length > 0) {
                    updatedFavoritos.push(data.articulo[0]);
                } else if (data && data.error) {
                    console.log('Error from API for item:', item);
                    // Only remove if API explicitly returns an error
                    const favoritosStorage = localStorage.getItem('favoritos_MVC');
                    if (favoritosStorage) {
                        let currentFavoritos = JSON.parse(favoritosStorage);
                        currentFavoritos = currentFavoritos.filter(fav => 
                            !(fav.articulo === item.articulo && fav.grupo === item.grupo)
                        );
                        localStorage.setItem('favoritos_MVC', JSON.stringify(currentFavoritos));
                    }
                }
            } catch (error) {
                console.error('Error fetching item:', item, error);
            }
        }
        console.log('Final favoritos:', updatedFavoritos);
        setFavoritos(updatedFavoritos);
        setLoading(false);
    };

    const handleStorageChange = () => {
        const favoritosStorage = localStorage.getItem('favoritos_MVC');
        console.log('Raw favoritos storage:', favoritosStorage);
        
        if (favoritosStorage) {
            try {
                const parsedFavoritos = JSON.parse(favoritosStorage);
                console.log('Parsed favoritos:', parsedFavoritos);
                fetchFavoritos(parsedFavoritos);
            } catch (error) {
                console.error('Error parsing favoritos from localStorage', error);
                setFavoritos([]);
                setLoading(false);
            }
        } else {
            setFavoritos([]);
            setLoading(false);
        }
    };

    useEffect(() => {
        handleStorageChange();

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const handleDelete = (articuloId, grupo) => () => {
        const favoritosStorage = localStorage.getItem('favoritos_MVC');
        if (favoritosStorage) {
            let parsedFavoritos = JSON.parse(favoritosStorage);
            parsedFavoritos = parsedFavoritos.filter(item => !(item.articulo === articuloId && item.grupo === grupo));
            localStorage.setItem('favoritos_MVC', JSON.stringify(parsedFavoritos));
            window.dispatchEvent(new Event('storage'));
            toast.success('Producto eliminado de favoritos');
        }
    }

    return (
        <Layout>
            <section className='relative w-full px-[5vw] py-8 lg:py-10 flex flex-col lg:flex-row justify-start items-start gap-5'>
                {
                    loading &&
                    <div className="w-full h-full flex justify-center items-center absolute z-50 bg-white/95 top-0 left-0">
                        <TbLoader3 size={60} className='stroke-azul animate-spin' />
                    </div>
                }
                <div className={`flex flex-col justify-start items-start gap-4 w-full ${favoritos && favoritos.length ? "lg:w-9/12" : "lg:w-full"} `}>
                    {
                        favoritos && favoritos.length !== 0 &&
                        (
                            <h2 className='font-medio text-azul text-2xl lg:text-2xl text-left border-b-2 border-b-azul w-fit pb-1 tracking-tight px-5 flex flex-row justify-start items-start gap-3'>
                                Mis favoritos
                                <div className='size-6 bg-azul text-white flex justify-center items-center rounded-full text-xs -mt-1 font-negro'>
                                    {favoritos.length}
                                </div>
                            </h2>
                        )
                    }
                    {
                        favoritos && favoritos.length === 0 ?
                        (
                            <div className='w-full flex flex-col justify-center items-center'>
                                <p className='text-center pt-10 text-lg lg:text-2xl text-azul font-medio'>Tu lista de favoritos está vacía.</p>
                                <p className='text-center pb-10'>Navega en muebleria-villarreal.com y agrega los productos que te gustan.</p>
                                <a href="/" className='w-full lg:w-fit bg-darkGris text-center py-3 lg:py-2 px-4 text-white text-sm rounded lg:hidden'>Regresar a Tienda</a>
                            </div>
                        )
                        :
                        (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
                                {favoritos.map((item, index) => (
                                    <div key={index} className="relative bg-white shadow p-4 rounded-lg">
                                        <div onClick={handleDelete(item.articulo, item.grupo)} className='size-6 rounded-full shadow bg-rojo flex justify-center items-center text-[8px] font-negro absolute top-2 right-2 z-20 cursor-pointer transition-all'>
                                            <FaRegTrashAlt size={12} fill='white' />
                                        </div>
                                        <img 
                                            src={"https://s3.us-east-2.amazonaws.com/cdn.muebleriavillarreal/mvcweb/images/articulos_img/" + item.departamento + "/" + item.articulo + ".jpg?quality=auto&format=webp"} 
                                            alt={item.descripcion_corta}
                                            className='w-full h-48 object-cover rounded-lg cursor-pointer mb-4' 
                                            onClick={() => window.location.href = "/Articulo/" + item.articulo + "/" + item.grupo}
                                        />
                                        <h3 className="font-medio text-lg mb-2">
                                            <a href={"/Articulo/" + item.articulo + "/" + item.grupo} className="hover:text-azul">
                                                {item.descripcion_corta}
                                            </a>
                                        </h3>
                                        <p className="text-rojo font-medio text-lg">
                                            {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.precio_contado)}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        )
                    }
                    <a href="/" className='w-full lg:w-fit bg-darkGris text-center py-3 lg:py-2 px-4 text-white text-sm rounded hidden lg:block'>Regresar a Tienda</a>
                </div>
            </section>
        </Layout>
    )
}

export default Favoritos